import React from 'react';
import '../styles/Loader.css';

function Loader({ text = 'Loading...', dotColor = '#0097A7' }) {
  return (
    <div className="modern-preloader">
      <div className="orbit-container">
        {[...Array(3)].map((_, i) => (
          <div 
            key={i}
            className="orbit-dot"
            style={{
              animationDelay: `${i * 0.2}s`,
              backgroundColor: dotColor
            }}
          />
        ))}
      </div>
      {text && <p className="loader-text">{text}</p>}
    </div>    
  );
}

export default Loader;
